import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import PassiveEnforcement from 'components/billing/passive_enforcement'
import {
  canManageBillingSelector,
  featureTierSelector,
} from 'features/billing'
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events'

const BillingInlineEnforcement = ({ feature, children }) => {
  const requiredTier = useSelector((state) => featureTierSelector(state, { featureKey: feature }))
  const canManageBilling = useSelector(canManageBillingSelector)
  const track = useTrack()

  useEffect(() => {
    if (canManageBilling) {
      track({
        name: TRACKING_EVENT_NAMES.PAYWALL_SHOWN,
        entities: ['user', 'organization', 'attribution'],
        properties: {
          paywall_feature: feature,
          paywall_type: 'inline',
          plan_required: requiredTier.toLowerCase()
        }
      })
    }
  }, [
    requiredTier,
    feature,
    canManageBilling,
    track,
  ])

  return canManageBilling ? children : <PassiveEnforcement featureKey={feature} />
}

export default BillingInlineEnforcement
